import React, { useState } from "react";
import s from "./PopoverItems.module.scss";

import Delete from "../../../../../../../global components/Icons/Delete/Delete";
import Edit from "../../../../../../../global components/Icons/Edit/Edit";
import ReusableDrawer from "../../../../../../../global components/Drawer/ReuseableDrawer";

import clsx from "clsx";
import { Oval } from "react-loader-spinner";
import useSWRMutation from "swr/mutation";
import {
  parseClientError,
  swrMutationFetcher,
  SwrMutationFetcherArgType,
} from "../../../../../../../libs/api/Endpoints";
import { UseAuthToken } from "../../../../../../../libs/api/userSession";
import ModifyMemberForm from "../../ModifyMemberForm";
import { generateConfirmation } from "../../../../../../../global components/DestructiveModal/DestruvtiveModal";
import { SuccessDataType } from "../../../../../../../libs/api/types";
import { generateResult } from "../../../../../../../global components/ResultModal/ResultModal";
interface PopOverItemsProps {
  keyValue: string; // Add a prop for the key value
  mutate: () => void;
}
function PopOverItems({ keyValue, mutate }: PopOverItemsProps) {
  const [open, setOpen] = useState<boolean>(false);
  
  const { trigger: deleteMember, isMutating } = useSWRMutation(
    `api/admin/team/members/${keyValue}`,
    swrMutationFetcher
  );

  const token = UseAuthToken();
  const deleteTeamMember = async () => {
    try {
      const fetcherArg: SwrMutationFetcherArgType = {
        token,
        requestOption: {
          method: "DELETE",
        },
      };
      const result: SuccessDataType<any> = await deleteMember(fetcherArg);
      generateResult(
        "success",
        result.message.charAt(0).toUpperCase() + result.message.slice(1)
      );
      mutate();
    } catch (error) {
      const e = parseClientError(error);

      generateResult("error", e.message || e.error);
    }
  };
 
  const handleOpen = () => {
    setOpen((prev) => !prev);
  };


  return (
    <>
      <ReusableDrawer title=" Modify role" Open={open} handleOpen={handleOpen}>
        <ModifyMemberForm id={keyValue} handleOpen={handleOpen} />
      </ReusableDrawer>

      <div className={s.wrapper}>
        <span onClick={handleOpen} className={clsx(s.PopOverItem)}>
          <Edit width={18} height={18} />
          <h5>Edit</h5>
        </span>

        <span
          onClick={() =>
            generateConfirmation(
              "Delete team member?",
              "Are you sure you want to delete?",

              deleteTeamMember,
              isMutating
            )
          }
          className={s.PopOverItem}
        >
          <Delete width={18} height={18} />
          <h5>Delete</h5>
          <Oval
            visible={isMutating}
            height="18"
            width="18"
            color="#d52b1e"
            ariaLabel="oval-loading"
          />
        </span>
      </div>
    </>
  );
}

export default PopOverItems;
